const bodyClass = document.body.classList;

const fontSizeMap = {
  smallFont: 12,
  normal: 14,
  bigFont: 16,
  bigFont_1: 18,
  bigFont_2: 20,
  bigFont_3: 22
};

/**
 * 主题设置相关
 */
export default themesConfig => {
  const state = Vue.observable({
    themesConfig,
    setting: {
      // 全局字体大小：normal，bigFont
      fontSize: dsf.config.setting_public_default_size || 'normal',
      // 全局主题
      theme: dsf.config.setting_public_default_theme || 'darkred-theme',
      // 默认顶部导航栏是否窄条
      defaultHeaderMini: Number(dsf.config.setting_public_default_header_mini) || 0,
      // 默认顶部导航栏是否吸顶
      defaultHeaderCeiling: Number(dsf.config.setting_public_default_header_ceiling) || 0,
      // 默认侧边导航栏是否窄条
      defaultAsideMini: Number(dsf.config.setting_public_default_aside_mini) || 0
    }
  });
  // 字体大小映射
  dsf.setObjAttr(state.setting, 'fontSizeMap', fontSizeMap);
  // 同步主题配置
  let updateSystemCustom = _.throttle(function () {
    let obj = state.setting;
    if (dsf.config.setting_public_themes_save_to_server == 1) {
      dsf.custom.addSystem("themeConfig", obj).then(() => {
        dsf.storage.local.set("themeConfig", obj);
      }).catch(() => {
        dsf.storage.local.set("themeConfig", obj);
      });
    } else {
      dsf.storage.local.set("themeConfig", obj);
    }
  }, 300, {
    leading: false,
    trailing: true
  });
  Object.defineProperty(state, 'currentTheme', {
    enumerable: true,
    get: function () {
      return state.themesConfig[state.setting.theme];
    }
  });
  // 当前默认字体大小
  Object.defineProperty(state, 'currentFontSize', {
    enumerable: false,
    get: function () {
      return fontSizeMap[state.setting.fontSize] || 14;
    }
  });
  // 获取主题色
  Object.defineProperty(state, 'getThemeColor', {
    enumerable: false,
    get: function () {
      return function (key = 'normal') {
        if (!key) {
          return ''
        }
        if (key[0] == '@') {
          key = key.substring(1);
        }
        return this?.currentTheme?.[key] || null;
      }
    }
  });
  // 设置字体大小
  Object.defineProperty(state, 'setFontSize', {
    enumerable: false,
    get: function () {
      return function (to = dsf.config.setting_public_default_size || 'normal') {
        if (to != state.setting.fontSize) {
          Vue.set(state.setting, 'fontSize', to);
          updateSystemCustom();
        }
      }
    }
  });
  // 设置主题
  Object.defineProperty(state, 'setTheme', {
    enumerable: false,
    get: function () {
      return function (to = dsf.config.setting_public_default_theme || 'darkred-theme') {
        if (to != state.setting.theme) {
          Vue.set(state.setting, 'theme', to);
          updateSystemCustom();
        }
      }
    }
  });
  // 设置默认顶部导航栏是否窄条
  Object.defineProperty(state, 'setDefaultHeaderMini', {
    enumerable: false,
    get: function () {
      return function (to = Number(dsf.config.setting_public_default_header_mini) || 0) {
        if (to != state.setting.defaultHeaderMini) {
          Vue.set(state.setting, 'defaultHeaderMini', to);
          updateSystemCustom();
        }
      }
    }
  });
  // 设置默认顶部导航栏是否吸顶
  Object.defineProperty(state, 'setDefaultHeaderCeiling', {
    enumerable: false,
    get: function () {
      return function (to = Number(dsf.config.setting_public_default_header_ceiling) || 0) {
        if (to != state.setting.defaultHeaderCeiling) {
          Vue.set(state.setting, 'defaultHeaderCeiling', to);
          updateSystemCustom();
        }
      }
    }
  });
  // 设置默认顶部导航栏是否窄条
  Object.defineProperty(state, 'setDefaultAsideMini', {
    enumerable: false,
    get: function () {
      return function (to = Number(dsf.config.setting_public_default_aside_mini) || 0) {
        if (to != state.setting.defaultAsideMini) {
          Vue.set(state.setting, 'defaultAsideMini', to);
          updateSystemCustom();
        }
      }
    }
  });
  dsf.themeConfig = state;
  window.$$themeConfig = state.setting;

  return {
    data() {
      return {
        isDesigner: false,
        userSetting: {}
      }
    },
    computed: {
      themesConfig() {
        return state.themesConfig;
      },
      setting() {
        return state.setting;
      },
      currentTheme() {
        return state.currentTheme;
      }
    },
    watch: {
      'setting.fontSize'(to, from) {
        if (!this.isDesigner) {
          bodyClass.remove(from);
          bodyClass.add(to);
        }
        this.updateIFrame('setFontSize', to, from);
      },
      'setting.theme'(to, from) {
        bodyClass.remove(from);
        bodyClass.add(to);
        this.updateIFrame('setTheme', to, from);
      }
    },
    created() {
      if (window.location.href.indexOf("designer.html") > 0) {
        this.isDesigner = true
      }
      this.resetThemeSetting();

      this._storageListener = _.throttle(this.resetThemeSetting, 300, {
        leading: false,
        trailing: true
      });
      window.addEventListener('storage', this.storageListener, false);
    },
    beforeDestroy() {
      window.removeEventListener('storage', this.storageListener, false);
    },
    methods: {
      resetThemeSetting() {
        let themeConfig = dsf.custom.getSystem('themeConfig');
        if (themeConfig && !dsf.isEmptyObject(themeConfig)) {
          themeConfig.defaultHeaderMini = Number(themeConfig.defaultHeaderMini);
          themeConfig.defaultHeaderCeiling = Number(themeConfig.defaultHeaderCeiling);
          themeConfig.defaultAsideMini = Number(themeConfig.defaultAsideMini);
          state.setting = dsf.mix(state.setting, themeConfig, this.userSetting);
        }
        if (!this.isDesigner) {
          bodyClass.add(state.setting.fontSize);
          this.updateIFrame('setFontSize', state.setting.fontSize);
        }
        bodyClass.add(state.setting.theme);
        bodyClass.add(dsf.client.type);
        bodyClass.add('v' + dsf.client.info.version.split('.')[0]);
        bodyClass.add(dsf.client.info.os.replace(/\s+/, ''));
        bodyClass.add(dsf.client.info.device.replace(/\s+/, ''));
        setTimeout(() => {
          bodyClass.add('osv' + dsf.client.info.osVersion);
        }, 100);
        this.updateIFrame('setTheme', state.setting.theme);
      },
      storageListener(e) {
        if (e.key === 'themeConfig') {
          this._storageListener();
        }
      },
      // 获取主题色
      getThemeColor(key = 'normal') {
        return state.getThemeColor(key);
      },
      /**
       * 设置字体大小
       * @param to {String}
       *    **normal**：正常字体大小14px
       *    **bigFont**：字体大小16px。
       */
      setFontSize(to = dsf.config.setting_public_default_size || 'normal') {
        state.setFontSize(to);
      },
      /**
       * 设置主题
       * @param to {String} 类名
       */
      setTheme(to = dsf.config.setting_public_default_theme || 'darkred-theme') {
        state.setTheme(to);
      },
      /**
       * 设置默认顶部导航栏是否窄条
       * @param to
       */
      setDefaultHeaderMini(to = Number(dsf.config.setting_public_default_header_mini) || 0) {
        state.setDefaultHeaderMini(to);
      },
      /**
       * 设置默认顶部导航栏是否吸顶
       * @param to
       */
      setDefaultHeaderCeiling(to = Number(dsf.config.setting_public_default_header_ceiling) || 0) {
        state.setDefaultHeaderCeiling(to);
      },
      /**
       * 设置默认顶部导航栏是否窄条
       * @param to
       */
      setDefaultAsideMini(to = Number(dsf.config.setting_public_default_aside_mini) || 0) {
        state.setDefaultAsideMini(to);
      },
      // 把主题注入到iframe中
      updateIFrame(funName, to, from) {
        for (let i = 0; i < window.frames.length; i++) {
          let win = window.frames[i];
          //判断子窗口是否引入的dsf-sdk.js
          if (win?.$dsf?.sdk) {
            let watchType = "";
            let watchValue = null;
            if (funName == 'setFontSize') {
              watchType = "font-size";
              watchValue = state.setting.fontSize;
            }
            else {
              watchType = "theme";
              watchValue = state.setting.theme;
            }
            win?.dsf?.triggerThemeConfigChange?.(watchType, watchValue)
          }
          else {
            let vueApp = win.document.getElementById("app");
            vueApp = vueApp && vueApp.__vue__ && vueApp.__vue__.$root;
            let fun = null;
            // 如果嵌套的iframe是5.0平台的页面
            if (vueApp && vueApp.setting) {
              fun = vueApp[funName];
            }
            // 嵌套其他iframe
            else {
              fun = win[funName];
            }
            fun && fun(to, from);
          }

        }
      }
    }
  }
}